import styled, { css } from 'styled-components';
import { ContainerRef } from '../styles';

export const Container = styled(ContainerRef)`
 
flex-direction: column;


`;